import type { ComponentProps } from 'react'

import { t } from 'i18next'

import { Icon } from '@/components/icon'
import { Badge } from '@/components/ui/badge'
import { PopoverClose } from '@/components/ui/popover'

export interface ILegendaItem {
  variant?: 'success' | 'warning' | 'destructive' | 'default'
  color?: { fill: string; text: string }
  descricao: string
  icone?: ComponentProps<typeof Icon>['name']
  texto?: string
}

interface ILegendasEspelhoDeVendasProps {
  items?: ILegendaItem[]
  titulo?: string
}

const ITENS_PADRAO: ILegendaItem[] = [
  {
    variant: 'success',
    descricao: t('espelho-de-vendas:legendas.alta_procura'),
    icone: 'flame',
    texto: t('espelho-de-vendas:legendas.andar'),
  },
  {
    variant: 'success',
    descricao: t('espelho-de-vendas:legendas.disponivel'),
    texto: t('espelho-de-vendas:legendas.andar'),
  },
  {
    variant: 'warning',
    descricao: t('espelho-de-vendas:legendas.reservada'),
    texto: t('espelho-de-vendas:legendas.andar'),
  },
  {
    variant: 'destructive',
    descricao: t('espelho-de-vendas:legendas.indisponivel_reservada'),
    texto: t('espelho-de-vendas:legendas.andar'),
  },
]

export const LegendasEspelhoDeVendas = ({ items = ITENS_PADRAO, titulo }: ILegendasEspelhoDeVendasProps = {}) => {
  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-sm font-medium">{titulo ?? t('espelho-de-vendas:legendas.titulo')}</h3>
        <PopoverClose aria-label="Fechar legenda">
          <Icon name="close" size={20} />
        </PopoverClose>
      </div>
      <div className="flex flex-col gap-2">
        {items.map((item) => (
          <div
            key={`legenda-${item.descricao}-${item.icone ? '-icon' : ''}`}
            className="font-nunito flex items-center gap-2"
          >
            <Badge
              variant={item.variant}
              backgroundColor={item.color?.fill}
              textColor={item.color?.text}
              className="relative h-[42px] w-[42px] rounded-sm"
            >
              {item.texto && <span className="text-md font-medium">{item.texto}</span>}
              {item.icone && <Icon name={item.icone} className="text-destructive absolute right-1 bottom-1" />}
            </Badge>
            <span className="text-sm">{item.descricao}</span>
          </div>
        ))}
      </div>
    </>
  )
}
